import { Component, OnInit, Input } from '@angular/core';
import { LanguageService } from '../../services/lang/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() type: String;

  constructor(public language:LanguageService) { }

  ngOnInit() {
  }

}
